import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/article/findAllpage', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/article/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/article/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/article/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/article/delete/batch', {
    params: {
      ids
    }
  })
}
